(() => {
  'use strict';

  const PROPERTY_SELECTOR = [
    'input[name^="properties["]:not([data-ks-property-mirror="1"])',
    'select[name^="properties["]',
    'textarea[name^="properties["]'
  ].join(',');

  let timer;

  function wrapperFor(control) {
    const explicit = control.closest('[data-custom-property]');
    if (explicit) return explicit;

    let node = control.parentElement;
    let candidate = control;
    for (let i = 0; node && i < 5; i += 1, node = node.parentElement) {
      if (node.matches('form, product-info, sticky-atc-bar, .product-form__buttons, .product__block')) break;
      if (node.querySelector('[name="add"], quantity-input')) break;
      candidate = node;
    }
    return candidate;
  }

  function score(control, mainForm, productInfo) {
    if (control.closest('sticky-atc-bar')) return -10000;
    if (control.closest('form.installment')) return -9000;

    let value = 0;
    if (control.closest('.main-product-form') === mainForm) value += 1000;
    if (control.form === mainForm) value += 800;
    if (control.getAttribute('form') === mainForm.id) value += 800;
    if (control.closest('.product__block--buy_buttons')) value += 400;
    if (productInfo.contains(control)) value += 100;
    return value;
  }

  function restoreCanonical(control) {
    const wrapper = control.closest('[data-ks-secondary-property-hidden="1"]');
    if (!wrapper) return;
    wrapper.hidden = false;
    wrapper.style.removeProperty('display');
    delete wrapper.dataset.ksSecondaryPropertyHidden;
  }

  function hideSecondary(control, canonical) {
    const wrapper = wrapperFor(control);
    if (!wrapper || wrapper === canonical || wrapper.contains(canonical)) return;
    if (wrapper.matches('form, product-info, sticky-atc-bar, .product-form__buttons, .product__block')) return;

    wrapper.dataset.ksSecondaryPropertyHidden = '1';
    wrapper.hidden = true;
    wrapper.style.setProperty('display', 'none', 'important');
  }

  function cleanDuplicateProperties() {
    const productInfo = document.querySelector('product-info[data-product-id]');
    if (!productInfo) return;

    const mainForm = productInfo.querySelector('.main-product-form[data-product-id], .main-product-form');
    if (!mainForm) return;

    const controls = [...document.querySelectorAll(PROPERTY_SELECTOR)].filter((control) => {
      if (control.closest('sticky-atc-bar')) return true;
      if (control.closest('form.installment')) return true;
      if (productInfo.contains(control)) return true;
      return control.form === mainForm || control.getAttribute('form') === mainForm.id;
    });

    const groups = new Map();
    controls.forEach((control) => {
      const name = control.name || control.getAttribute('name');
      if (!name) return;
      if (!groups.has(name)) groups.set(name, []);
      groups.get(name).push(control);
    });

    groups.forEach((group) => {
      if (group.length < 2) {
        const only = group[0];
        if (only && score(only, mainForm, productInfo) >= 0) restoreCanonical(only);
        return;
      }

      let canonical = null;
      let bestScore = -Infinity;
      group.forEach((control) => {
        const controlScore = score(control, mainForm, productInfo);
        if (controlScore >= bestScore) {
          bestScore = controlScore;
          canonical = control;
        }
      });

      // Wait until the real main-product property exists before suppressing copies.
      if (!canonical || bestScore < 0) return;

      restoreCanonical(canonical);
      group.forEach((control) => {
        if (control !== canonical) hideSecondary(control, canonical);
      });
    });
  }

  function scheduleClean() {
    clearTimeout(timer);
    timer = setTimeout(cleanDuplicateProperties, 30);
  }

  function init() {
    cleanDuplicateProperties();
    document.addEventListener('shopify:section:load', scheduleClean);

    const observer = new MutationObserver(scheduleClean);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();
